import { Backdrop, Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, Switch, Typography } from "@mui/material";
import { useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from "react";
import * as yup from 'yup';
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { useDispatch } from "react-redux";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import axios from "axios";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { Delete, EditNote } from "@mui/icons-material";
import _ from "lodash";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";

const MainCategoryModal = ({ onCancel }) => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [active, setActive] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [isLoader, setIsLoader] = useState(false); //loader
  
const validationSchema = yup.object({
    category : yup.string().required(),
})

const formik = useFormik({
  initialValues :{
    category : ""
  },
  validationSchema:validationSchema,
// onSubmit: isEdit ? handleUpdate : handleCreate
onSubmit: (values) => {
  if (isEdit) {
    handleUpdate(values);
  } else {
    handleCreate(values);
  }
}
})
function handleCreate(){
    const catData = {
      category_name: formik.values.category,
      category_image: null,
      is_active : active
    }
    setIsLoader(true);
    axios.post('/v1/categories', catData)
    .then(res=>{
      setOpen(false)
      handleClose();
      getCategoryData()
      dispatch(setSnackbar(true, 'success', 'Created Successfully'))
      setIsLoader(false);
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
      console.log(err)
      setIsLoader(false);
    })
  }

  function onEdit(e){
    console.log(e)
    formik.setFieldValue('typeDesign', e.name)
    setActive(e.isActive)
    setIsEdit(true)
    setOpen(true)
    setActiveId(e.id)
  }

  function handleUpdate(){
    const catData = {
      category_name: formik.values.category,
      category_image: null,
      is_active : active
    }
    setIsLoader(true);
    axios.put(`/v1/categories/${activeId}`, catData)
    .then(res=>{
      setOpen(false)
      console.log(res)
      getCategoryData()
      dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
      setIsLoader(false);
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
      console.log(err)
      setIsLoader(false);
    })
  console.log('update')
  }
   
  
    const handleClose = () => {
      formik.resetForm();
      onCancel(false); // This will close the modal
    };
    const getCategoryData = () =>{
        const url = `/v1/categories/${rowsPerPage}/${page + 1}`
        const searchUrl = `/v1/categories/${rowsPerPage}/${page + 1}/${search}`
        setIsLoader(true);
        axios.get(search === '' ? url : searchUrl)
        .then(res=>{
          setData(res.data.data)
          setPageCount(res.data.meta.pagination.total)
          setIsLoader(false);
        })
        .catch(err=>{
          console.log(err)
          dispatch(setSnackbar(true, 'error', err.response.data.error))
          setIsLoader(false);
        })
      }
      
      useEffect(()=>{
      getCategoryData()
      
      },[rowsPerPage, page, search])
      
  return (

<Fragment>
<Modal onClose={handleClose} onSave={formik.handleSubmit} formik={formik} 

>

  <Grid container spacing={2}>
            <Grid item xs={12} >
            <CustomTextField id='category' value={formik.values.category} title='Main Category' multiple={false} placeholder='Enter Main Category' onchange={formik.handleChange} errorMsg={formik.touched.category && Boolean(formik.errors.category)} helperText={formik.touched.category && formik.errors.category}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3} className="flex items-center">
            <FormControlLabel  control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
            
          </Grid>
</Modal>
</Fragment>
  );
};

export default MainCategoryModal;
